import noop from "lodash/noop";
import React, { FunctionComponent, ReactNode } from "react";
import { useIntl } from "react-intl";
import addressIcon from "./images/address.svg";
import billingIcon from "./images/billing.svg";
import deliveryIcon from "./images/delivery.svg";
import discountIcon from "./images/discount.svg";
import orderIcon from "./images/order.svg";
import paymentIcon from "./images/payment.svg";
import "./style.scss";

type TileType = "address" | "billing" | "delivery" | "discount" | "order" | "payment";

interface Props {
  children: ReactNode;
  onClick?: (type: TileType) => void;
  type: TileType;
  warningBanner?: {
    text: string;
    textLink: string;
  };
}

const faqLinks: {
  [key: string]: {
    [key: string]: string;
  };
} = {
  delivery: {
    en: "en-us/categories/115001947647-Delivery",
    es: "es/categories/115001947647-Entrega",
    fr: "fr/categories/115001947647-Livraison",
    it: "it/categories/115001947647-Spedizione",
  },
  payment: {
    en: "en-us/sections/203722598-Payment-and-security",
    es: "es/sections/203722598-Pago-y-seguridad",
    fr: "fr/sections/203722598-Paiement-et-sécurité",
    it: "en-us/sections/203722598-Payment-and-security",
  },
};

const getIcon = (type: TileType) => {
  switch (type) {
    case "address":
      return addressIcon;
    case "billing":
      return billingIcon;
    case "delivery":
      return deliveryIcon;
    case "discount":
      return discountIcon;
    case "order":
      return orderIcon;
    case "payment":
      return paymentIcon;
    default:
      return addressIcon;
  }
};

const CartOverviewTile: FunctionComponent<Props> = ({ children, onClick, warningBanner, type }) => {
  const intl = useIntl();

  return (
    <div className="CartOverviewTile">
      {(type === "address" || type === "billing" || type === "order") && (
        <div className="CartOverviewTile-change" onClick={() => (onClick ? onClick(type) : noop)}>
          {intl.formatMessage({
            id: "cheerz_CartOverviewTile_change",
          })}
        </div>
      )}
      <img src={getIcon(type)} className="CartOverviewTile-icon" alt="" />
      <div className="CartOverviewTile-title">
        <p className="CartOverviewTile-title-text">
          {intl.formatMessage({
            id: `cheerz_CartOverviewTile_title_${type}`,
          })}
        </p>
        {faqLinks[type] && (
          <a
            className="CartOverviewTile-subtitle"
            href={`https://support.cheerz.com/hc/${faqLinks[type][intl.locale]}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {intl.formatMessage({
              id: `cheerz_CartOverviewTile_subtitle_${type}`,
            })}
          </a>
        )}
      </div>
      <div className="CartOverviewTile-content">{children}</div>
      {warningBanner && (
        <div className="CartOverviewTile-bannerContainer">
          <div className="CartOverviewTile-banner" onClick={() => (onClick ? onClick(type) : noop)}>
            <div className="CartOverviewTile-banner-text">{warningBanner.text}</div>
            <div className="CartOverviewTile-banner-link">{warningBanner.textLink}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CartOverviewTile;
